(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sh-magazine"]) return;
  try {
    
function openMagazineExcerpt() {
 const id = window.location.hash.slice(1);
 if (!id.startsWith('read-')) return;
 const element = document.getElementById(id);
 if (element && element.tagName === 'DETAILS') { element.open = true; element.scrollIntoView({block:'start'}); }
}
document.addEventListener('click', function(event) {
 const link = event.target.closest('a[href^="#read-"]');
 if (!link) return;
 const target = document.getElementById(link.getAttribute('href').slice(1));
 if (target) target.open = true;
});
window.addEventListener('hashchange', openMagazineExcerpt);
openMagazineExcerpt();

  } catch(e) { console.error(e); }
})();
})();
